









































import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { NewsConfigModel } from "@/api/models/accesPlateformeBeneficiaires/accesPlateformeBeneficiaire";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import {
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BFormTags,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  components: {
    BButton,
    BCol,
    BFormTags,
    BRow,
    BCard,
    BFormCheckbox,
    BSpinner,
    SearchableVueSelect,
    FeatherIcon,
  },
  name: "news-config",
})
export default class NewsConfig extends Vue {
  @Prop({ type: Boolean, required: true }) newsActive!: boolean;
  @Prop({ type: Array, required: true }) newsTags!: string[];
  @Prop({ type: String, required: true })
  accesPlateformeBeneficiaireId!: string;
  @Prop({ type: Array, required: true }) tagsList!: string[];


  localNewsActive: boolean = this.newsActive;
  localNewsTags: string[] = [...this.newsTags];

  syncing: boolean = false;

  async created() {
    
  }

  

  @Watch("newsActive")
  onNewsActiveChanged(val: boolean) {
    this.localNewsActive = val;
  }

  @Watch("newsTags")
  onNewsTagsChanged(val: string[]) {
    this.localNewsTags = [...val];
  }

  onToggleNews() {
    if (!this.localNewsActive) {
      this.localNewsTags = [];
    }
    this.$emit("update:news-active", this.localNewsActive);
  }

  async saveNewsConfiguration() {
    try {
      var newsConfig: NewsConfigModel = {
        newsActive: this.localNewsActive,
        newsTags: this.localNewsTags || [],
      };

      await this.$http.myressif.accesPlateformeBeneficiaire.updateNewsConfig(
        this.accesPlateformeBeneficiaireId,
        newsConfig
      );

      successAlert.fire({
        title: "Configuration des news",
        text: "Configuration enregistrée avec succès.",
      });

      this.$emit("reload");

      return true;
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur d'enregistrement",
        text: error?.response?.data?.detail || error.message,
      });
      return false;
    }
  }
  async syncNewsConfiguration() {
    try {
      await this.saveNewsConfiguration();

      await this.$http.myressif.accesPlateformeBeneficiaire.syncNewsConfig(
        this.accesPlateformeBeneficiaireId
      );

      successAlert.fire({
        title: "Synchronisation des tags de news",
        text: "Synchronisation effectuée avec succès.",
      });
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur de synchronisation",
        text: error?.response?.data?.detail || error.message,
      });
    } finally {
      this.$emit("reload");
    }
  }
}
